import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, ReportIdSchema, RevisionIdSchema, RunIdSchema, } from "../primitives/ids.js";
import { QualityGateStatusSchema } from "./quality-gate-result.js";
import { ReportCheckSummaryV1Schema, ReportCoverageSummaryV1Schema } from "./report-check-summary.js";
import { ReportLifecycleStatusSchema, ReportTypeSchema, SEARCH_READINESS_RULE_SET_VERSION } from "./report-lifecycle.js";
/** search-readiness-report.v1.0 — canonical composed report document (internal storage). */
export const SearchReadinessReportV1Schema = z
    .object({
    schemaVersion: z.literal("search-readiness-report.v1.0"),
    reportId: ReportIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    reportType: z.literal("SEARCH_READINESS"),
    lifecycleStatus: ReportLifecycleStatusSchema,
    ruleSetVersion: z.literal(SEARCH_READINESS_RULE_SET_VERSION),
    businessGraphRevisionId: RevisionIdSchema,
    artifactSetHash: z.string().min(1),
    runId: RunIdSchema,
    qaStatus: QualityGateStatusSchema,
    headline: z.string().min(1),
    staleBanner: z.string().min(1).nullable(),
    coverage: ReportCoverageSummaryV1Schema,
    checks: z.array(ReportCheckSummaryV1Schema),
    whatWeDoNotPromise: z.array(z.string().min(1)).min(1),
    generatedAt: z.string().datetime(),
})
    .strict();
/** QualityReportSummaryV1 — rollup section shared across report families. */
export const QualityReportSummaryV1Schema = z
    .object({
    schemaVersion: z.literal("quality-report-summary.v1.0"),
    qaStatus: QualityGateStatusSchema,
    coverage: ReportCoverageSummaryV1Schema,
    headline: z.string().min(1),
})
    .strict();
/** LaunchReadinessReportV1 — Step 7 direction stub (DK / labels deferred). */
export const LaunchReadinessReportV1Schema = z
    .object({
    schemaVersion: z.literal("launch-readiness-report.v1.0"),
    reportId: ReportIdSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    reportType: z.literal("LAUNCH_READINESS_DIRECTION"),
    lifecycleStatus: ReportLifecycleStatusSchema,
    directionNote: z.string().min(1),
    qualitySummary: QualityReportSummaryV1Schema,
    generatedAt: z.string().datetime(),
})
    .strict();
export const ReportGenerateRequestV1Schema = z
    .object({
    schemaVersion: z.literal("report-generate-request.v1.0"),
    reportType: ReportTypeSchema.default("SEARCH_READINESS"),
    runId: RunIdSchema.optional(),
    idempotencyKey: z.string().min(1).max(512).optional(),
})
    .strict();
export const ReportGenerateResultV1Schema = z
    .object({
    schemaVersion: z.literal("report-generate-result.v1.0"),
    reportId: ReportIdSchema,
    lifecycleStatus: ReportLifecycleStatusSchema,
    idempotencyKey: z.string().min(1),
})
    .strict();
//# sourceMappingURL=search-readiness-report.js.map